<template>
  <div>
    <img
      :src="image"
      width="150"
      height="150"
      :alt="alt"
      class="prismic-image-list img-fluid"
      loading="lazy"
    />

    <prismic-rich-text
      :field="title"
      class="prismic-text-list text-center align-items-center justify-content-center"
    ></prismic-rich-text>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss">
.prismic-image-list {
  border-radius: 8px;
}
.prismic-text-list {
  color: #707070;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  letter-spacing: 0px;
  margin: 10px 0px;
  padding: 0px;
  padding-bottom: 20px;
  opacity: 1;
}
</style>
